import React from 'react'
import './link.css'

export const Link = ({ name }) => {
    return <div className="link-name">{name}</div>
}
